var a={card:"contact-mapa-style-module_card__nxxzg"};export{a as default};
//# sourceMappingURL=contact-mapa.style.module.scss.js.map
